import { toUserStatusText } from '@/core/presenter/transfer/toActivities';
import * as ViewModel from '@/core/presenter/viewModel/viewTypes';
import clsx from 'clsx';
import { useCallback } from 'react';

interface IProps {
  lastLoginTime: string;
  isOpen: boolean;
  userStatus: number;
  isLogoutModalOpen: boolean;
  onClickToggleBtn: () => void;
  onClickLogoutBtn: () => void;
  onClickLogoutModalClose: () => void;
  onClickLogoutModalConfirm: () => void;
  onChangeSettingViewType: (type: ViewModel.SettingViewType) => void;
  onClickAddHomeBtn: () => void;
}

const MainView = ({
  lastLoginTime,
  isOpen,
  userStatus,
  isLogoutModalOpen,
  onClickToggleBtn,
  onClickLogoutBtn,
  onClickLogoutModalClose,
  onClickLogoutModalConfirm,
  onChangeSettingViewType,
}: IProps) => {
  const handleClickMovePinSettingView = useCallback(() => {
    onChangeSettingViewType(ViewModel.SettingViewType.PIN_SETTING);
  }, [onChangeSettingViewType]);

  return (
    <div className="setting-content setting-container">
      <div className="setting-card">
        {/* 계정 관리 섹션 */}
        <div className="setting-section">
          <button type="button" className="setting-section-header" onClick={onClickToggleBtn}>
            <div className="setting-section-title-wrapper">
              <img src="./images/account-icon.png" alt="계정 관리" className="setting-section-icon" />
              <span className="setting-section-title text-lg font-bold">계정 관리</span>
            </div>
            <img src="./images/arrow-down.png" alt="arrow-down" className="setting-arrow" />
          </button>

          <div className="setting-section-divider"></div>

          <div className={clsx('setting-menu-list', !isOpen && 'hidden')}>
            <a
              href="#"
              className="setting-menu-item text-base font-medium"
              onClick={() => onChangeSettingViewType(ViewModel.SettingViewType.PWD_SETTING)}
            >
              비밀번호 재설정
            </a>
            <a
              href="#"
              className="setting-menu-item text-base font-medium"
              onClick={handleClickMovePinSettingView}
            >
              PIN비밀번호 재설정
            </a>
            {toUserStatusText(userStatus) === ViewModel.UserStatus.ADMIN && (
              <a
                href="#"
                className="setting-menu-item text-base font-medium"
                onClick={() => onChangeSettingViewType(ViewModel.SettingViewType.MANAGE_WALLET_BALANCE)}
              >
                관리지갑 잔액 확인
              </a>
            )}
            <a
              href="#"
              className="setting-menu-item text-base font-medium"
              onClick={onClickLogoutBtn}
            >
              로그아웃
            </a>
            <a
              href="#"
              className="setting-menu-item text-base font-medium"
              onClick={() => onChangeSettingViewType(ViewModel.SettingViewType.EXIT)}
            >
              계정 및 보안
            </a>
          </div>
        </div>

        {/* 마지막 로그인 시간 */}
        {lastLoginTime && (
          <div className="setting-footer">
            <span className="setting-last-login text-sm font-normal">마지막 로그인일시: {lastLoginTime}</span>
          </div>
        )}
      </div>

      {/* 로그아웃 확인 모달 */}
      <div className={clsx('modal-overlay', !isLogoutModalOpen && 'hidden')} id="logoutModal">
        <div className="modal-content modal-small">
          <button type="button" className="modal-close" onClick={onClickLogoutModalClose}>
            <img src="./images/close-icon.png" alt="닫기" className="close-icon" />
          </button>

          <div className="modal-body">
            <h2 className="modal-confirm-title text-base font-bold">로그아웃 하시겠습니까?</h2>

            <div className="modal-confirm-buttons">
              <button
                type="button"
                className="modal-confirm-no text-lg font-semibold"
                onClick={onClickLogoutModalClose}
              >
                아니오
              </button>
              <button
                type="button"
                className="modal-confirm-yes text-lg font-semibold"
                onClick={onClickLogoutModalConfirm}
              >
                예
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainView;
